// extracted by mini-css-extract-plugin
export default {"image":"ZY-z","loaded":"_Y-z"};